import portalAxiosInstance from './portalAxiosInstance';

const PortalQuoteService = {
    getQuotes: () =>
        portalAxiosInstance.get('/api/portal/quotes').then(r => r.data),

    getQuote: (id) =>
        portalAxiosInstance.get(`/api/portal/quotes/${id}`).then(r => r.data),

    accept: (id) =>
        portalAxiosInstance.post(`/api/portal/quotes/${id}/accept`).then(r => r.data),

    decline: (id) =>
        portalAxiosInstance.post(`/api/portal/quotes/${id}/decline`).then(r => r.data),

    requestChanges: (id, comment) =>
        portalAxiosInstance.post(`/api/portal/quotes/${id}/request-changes`, { comment }).then(r => r.data),

    downloadPdf: (id) =>
        portalAxiosInstance.get(`/api/portal/quotes/${id}/pdf`, { responseType: 'blob' }),
};

export default PortalQuoteService;
